
/* eslint-disable @typescript-eslint/no-shadow */
export namespace DayOfWeek {
  export enum DayOfWeek {
    SUN = "SUN",
    MON = "MON",
    TUE = "TUE",
    WED = "WED",
    THU = "THU",
    FRI = "FRI",
    SAT = "SAT",
  }

  export interface DayOfWeekDTO {
    case: string;
  }

  export const fromDTO = (dto: DayOfWeekDTO): DayOfWeek => {
    if (dto === undefined || dto === null) {
      throw new InvalidDayOfWeekError(
        `Invalid DTO ${dto} provided for DayOfWeek.DayOfWeek`
      );
    }
    switch (dto.case) {
      case "SUN":
        return DayOfWeek.SUN;
      case "MON":
        return DayOfWeek.MON;
      case "TUE":
        return DayOfWeek.TUE;
      case "WED":
        return DayOfWeek.WED;
      case "THU":
        return DayOfWeek.THU;
      case "FRI":
        return DayOfWeek.FRI;
      case "SAT":
        return DayOfWeek.SAT;
      default:
        throw new InvalidDayOfWeekError(
          `Case ${dto.case} is not valid case of DayOfWeek.DayOfWeek`
        );
    }
  };

  export const toDTO = (dayOfWeek: DayOfWeek): DayOfWeekDTO => {
    const enumDTO = {
      case: DayOfWeek[dayOfWeek],
    };
    return enumDTO;
  };
}

export class InvalidDayOfWeekError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDayOfWeekError";
  }
}
export class InvalidDayOfWeekSunError extends InvalidDayOfWeekError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDayOfWeekSunError";
  }
}

export class InvalidDayOfWeekMonError extends InvalidDayOfWeekError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDayOfWeekMonError";
  }
}

export class InvalidDayOfWeekTueError extends InvalidDayOfWeekError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDayOfWeekTueError";
  }
}

export class InvalidDayOfWeekWedError extends InvalidDayOfWeekError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDayOfWeekWedError";
  }
}

export class InvalidDayOfWeekThuError extends InvalidDayOfWeekError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDayOfWeekThuError";
  }
}

export class InvalidDayOfWeekFriError extends InvalidDayOfWeekError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDayOfWeekFriError";
  }
}

export class InvalidDayOfWeekSatError extends InvalidDayOfWeekError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidDayOfWeekSatError";
  }
}
